import { addDays, format, subYears } from 'date-fns';

import { IGetReportsActionParams, IReportsDataCtx } from './types';

export const reportsInitialValues: IReportsDataCtx = {
  reports: null,
  users: null,
  error: null,
  fetching: false,
  fetchingUsers: false,
  fetchingFilters: false,
  getReportCreators: async () => {
    // no-op default to satisfy linter; real implementation provided by provider
    return;
  },
  reportCreators: [],
  fetchingReportCreators: false,
};

export const reportsInitialParams: IGetReportsActionParams = {
  from_date: format(subYears(new Date(), 1), 'yyyy-MM-dd'),
  to_date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
  page: 1,
  page_size: 20,
  ordering: '-created_at',
};

export const reportStatus: {
  pending: string;
  completed: string;
  error: string;
  partialFinished: string;
} = {
  pending: 'pending',
  completed: 'finished',
  error: 'error',
  partialFinished: 'partial_finished',
};
